export const ASSESSMENTS_CONFIG = {
  swipe: {
    label: 'general.tests.name.swipe',
    icon: 'fat fa-fingerprint'
  },
  shape: {
    label: 'general.tests.name.swipe',
    icon: 'fat fa-fingerprint'
  },
  drive: {
    label: 'general.tests.name.drive',
    icon: 'fat fa-rocket-launch'
  },
  brain: {
    label: 'general.tests.name.brain',
    icon: 'fat fa-brain-circuit'
  },
  voice: {
    label: 'general.tests.name.voice',
    icon: 'fat fa-waveform-lines'
  },
  screening: {
    label: 'general.tests.name.scan',
    icon: 'fat fa-crosshairs'
  }
};
